import { Component } from '@angular/core';
import { SharedModule } from 'src/app/shared';

@Component({
  selector: 'app-psd2',
  imports: [SharedModule],
  templateUrl: './psd2.component.html',
  styleUrl: './psd2.component.scss'
})
export class Psd2Component {

}
